import "./TemplatesEmptyStateComponent.scss";

import { Flex, Text } from "@fluentui/react-northstar";
import React from "react";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";

import EmptyTemplatesImage from "../../_shared/assets/templates-empty-state.svg";
import { getAuthoringPath } from "../utils/getAuthoringPath";

export const TemplatesEmptyStateComponent: React.FC = () => {
  const location = useLocation();
  return (
    <div className="container">
      <Flex
        column
        className="templates-empty-state"
        hAlign="center"
        vAlign="center"
        gap="gap.small"
        fill
      >
        <img src={EmptyTemplatesImage} height={200} alt="No Templates" />
        <Text
          content="You haven't saved any templates yet."
          className="templates-empty-state__heading"
        />
        <Text
          size="small"
          weight="regular"
          className="templates-empty-state__sub-heading"
          content={
            <p>
              All your custom templates will appear here. Create a
              <Link
                className="brand-link"
                to={`${getAuthoringPath("poll", location, {
                  trackingSource: "templates-empty-state",
                })}`}
              >
                {" "}
                new polly{" "}
              </Link>
              and save it as a template.
            </p>
          }
        />
      </Flex>
    </div>
  );
};
